import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = theme => ({
  root: {
    padding: theme.spacing(1),
  },
});

const TableHeadItem = ({
  item,
  className,
  classes,
}) => {
  const { title } = item;
  return (
    <td
      className={classNames(classes.root, className)}
      title={title}
    >
      <Typography
        variant={'h5'}
        color={'primary'}
        weight={'bold'}
      >
        {title}
      </Typography>
    </td>
  );
};

TableHeadItem.defaultProps = {
  className: '',
  item: null,
};

TableHeadItem.propTypes = {
  item: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableHeadItem);
